import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { checkLogin } from '../reducer/user';
import Loading from './loading';

const style = {
    width: '140px',
    height: '45px',
    display: 'block',
    textIndent: '-9999px',
    background: 'url(https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/logo.png) 0 0 no-repeat'
};

const Mapping = [
    { match: /^\/$/, id: 'home' },
    { match: /^\/vip/, id: 'vip' },
    { match: /^\/shop/, id: 'shop' },
    { match: /^\/login/, id: 'login' },
];

class header extends React.Component {
    componentWillMount() {
        this.props.checkLogin();
    }
    render() {
        const { isLogin, loading, pathname = window.location.pathname } = this.props;
        const selected = (Mapping.find(entry => entry.match.test(pathname)) || { id: '' }).id;
        return (
            <nav className="navbar navbar-default navbar-fixed-top">
                <div className="container">
                    <div className="navbar-header" style={{ marginLeft: '0px' }}>
                        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                        <a style={style} className="navbar-brand" href="http://www.pubgame.tw">Pubgame</a>
                    </div>
                    <div id="navbar" className="collapse navbar-collapse">
                        <ul className="nav navbar-nav">
                            <li className={selected === 'home' ? 'active' : 'non-active'}><Link to="/">活動說明</Link></li>
                            <li className={selected === 'vip' ? 'active' : 'non-active'}><Link to="/vip" className="link_vip">我的VIP</Link></li>
                            <li className={selected === 'shop' ? 'active' : 'non-active'}><Link to="/shop" className="link_shop">VIP專屬儲值</Link></li>
                            <li><a href="http://www.pubgame.tw/shop/ex.do">兌換點數</a></li>
                        </ul>
                        <ul className="nav navbar-nav navbar-right">
                            {loading && <li><div style={{ height: '50px' }}><Loading /></div></li>}
                            {(!loading && !isLogin) && <li className={selected === 'login' ? 'active' : 'non-active'}><Link to="/login">登入</Link></li>}
                            {(!loading && isLogin) && <li><a href="/logout">登出</a></li>}
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}
header.propTypes = {
    isLogin: PropTypes.bool.isRequired
};

header.defaultProps = {
    isLogin: true
}

const mapStateToProps = state => ({
    isLogin: state.user.isLogin,
    loading: state.user.loading,
    pathname: state.user.pathname
})

const mapDispatchToProps = dispatch => bindActionCreators({
    checkLogin
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(header)



// WEBPACK FOOTER //
// ./src/components/header.jsx